export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

export const ALLOWED_FILE_TYPES_MESSAGE = 'Only JPG, PNG, JPEG and GIF files are allowed';

export const ALLOWED_FILE_SIZE = 10 * 1024 * 1024;

export const ALLOWED_FILE_SIZE_MESSAGE = 'File size must be less than 10MB';
